// @ts-nocheck
import { useEffect, useState, useCallback } from 'react';

/**
 * Hook to persist and restore column widths from localStorage
 */
export function useColumnResize(tableId: string) {
  const [columnSizing, setColumnSizing] = useState<Record<string, number>>({});

  // Load saved column widths from localStorage
  useEffect(() => {
    const saved = localStorage.getItem(`table-column-sizes-${tableId}`);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setColumnSizing(parsed);
      } catch (e) {
        console.error('Failed to parse saved column sizes:', e);
      }
    }
  }, [tableId]);

  // Save column widths to localStorage
  // This function can be called with either an updater function or a new state object
  const saveColumnSizing = useCallback(
    (updaterOrValue: Record<string, number> | ((old: Record<string, number>) => Record<string, number>)) => {
      setColumnSizing((old) => {
        const newSizing = typeof updaterOrValue === 'function' ? updaterOrValue(old) : updaterOrValue;
        localStorage.setItem(`table-column-sizes-${tableId}`, JSON.stringify(newSizing));
        return newSizing;
      });
    },
    [tableId]
  );

  return { columnSizing, saveColumnSizing };
}

